import { render, staticRenderFns } from "./EditTHGCarVRCModal.vue?vue&type=template&id=4f02aee2"
import script from "./EditTHGCarVRCModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditTHGCarVRCModal.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports